module.exports = __webpack_public_path__ + "baja_logo.png?4e81d50cf3347533412924276807b87e";